import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=02879cdc"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02879cdc')) {
      api.createRecord('02879cdc', component.options)
    } else {
      api.reload('02879cdc', component.options)
    }
    module.hot.accept("./actions.vue?vue&type=template&id=02879cdc", function () {
      api.rerender('02879cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/edition/components/actions.vue"
export default component.exports